export default __webpack_public_path__ + "static/logo-dfa588718796894307d2c27c1851f989.png";